import {
  itemUploadCallback as publicItemUploadCallback,
  generateFileUploadUrl as publicGenerateFileUploadUrl,
  importFile as publicImportFile,
  bulkImportFiles as publicBulkImportFiles,
  searchItems as publicSearchItems,
  queryItems as publicQueryItems,
  typedQueryItems as publicTypedQueryItems,
  updateItem as publicUpdateItem,
  bulkUpdateItem as publicBulkUpdateItem,
  getItem as publicGetItem,
  linkItemToCategories as publicLinkItemToCategories,
  unlinkItemFromCategories as publicUnlinkItemFromCategories,
  overwriteItemCategories as publicOverwriteItemCategories,
} from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  EnterpriseMediaItemQuery,
  ItemsQueryBuilder,
  typedQueryItems as universalTypedQueryItems,
} from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.universal.js';
import { onEnterpriseItemCreated as publicOnEnterpriseItemCreated } from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.public.js';
import { onEnterpriseItemItemCategoriesChanged as publicOnEnterpriseItemItemCategoriesChanged } from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.public.js';
import { onEnterpriseItemPublishStatusChanged as publicOnEnterpriseItemPublishStatusChanged } from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.public.js';
import { onEnterpriseItemUpdated as publicOnEnterpriseItemUpdated } from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.public.js';

function customQueryItems(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryItems(httpClient)(),
    typedQueryFunction: (query: EnterpriseMediaItemQuery) =>
      publicTypedQueryItems(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ItemsQueryBuilder;
  function overloadedQuery(
    query: EnterpriseMediaItemQuery
  ): ReturnType<typeof universalTypedQueryItems>;
  function overloadedQuery(query?: EnterpriseMediaItemQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const itemUploadCallback: MaybeContext<
  BuildRESTFunction<typeof publicItemUploadCallback> &
    typeof publicItemUploadCallback
> = /*#__PURE__*/ createRESTModule(publicItemUploadCallback);
export const generateFileUploadUrl: MaybeContext<
  BuildRESTFunction<typeof publicGenerateFileUploadUrl> &
    typeof publicGenerateFileUploadUrl
> = /*#__PURE__*/ createRESTModule(publicGenerateFileUploadUrl);
export const importFile: MaybeContext<
  BuildRESTFunction<typeof publicImportFile> & typeof publicImportFile
> = /*#__PURE__*/ createRESTModule(publicImportFile);
export const bulkImportFiles: MaybeContext<
  BuildRESTFunction<typeof publicBulkImportFiles> & typeof publicBulkImportFiles
> = /*#__PURE__*/ createRESTModule(publicBulkImportFiles);
export const searchItems: MaybeContext<
  BuildRESTFunction<typeof publicSearchItems> & typeof publicSearchItems
> = /*#__PURE__*/ createRESTModule(publicSearchItems);
export const updateItem: MaybeContext<
  BuildRESTFunction<typeof publicUpdateItem> & typeof publicUpdateItem
> = /*#__PURE__*/ createRESTModule(publicUpdateItem);
export const bulkUpdateItem: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateItem> & typeof publicBulkUpdateItem
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateItem);
export const getItem: MaybeContext<
  BuildRESTFunction<typeof publicGetItem> & typeof publicGetItem
> = /*#__PURE__*/ createRESTModule(publicGetItem);
export const linkItemToCategories: MaybeContext<
  BuildRESTFunction<typeof publicLinkItemToCategories> &
    typeof publicLinkItemToCategories
> = /*#__PURE__*/ createRESTModule(publicLinkItemToCategories);
export const unlinkItemFromCategories: MaybeContext<
  BuildRESTFunction<typeof publicUnlinkItemFromCategories> &
    typeof publicUnlinkItemFromCategories
> = /*#__PURE__*/ createRESTModule(publicUnlinkItemFromCategories);
export const overwriteItemCategories: MaybeContext<
  BuildRESTFunction<typeof publicOverwriteItemCategories> &
    typeof publicOverwriteItemCategories
> = /*#__PURE__*/ createRESTModule(publicOverwriteItemCategories);
export const queryItems: MaybeContext<
  BuildRESTFunction<typeof customQueryItems> & typeof customQueryItems
> = /*#__PURE__*/ createRESTModule(customQueryItems);
/**
 * Triggered when an item is created.
 */
export const onEnterpriseItemCreated: BuildEventDefinition<
  typeof publicOnEnterpriseItemCreated
> &
  typeof publicOnEnterpriseItemCreated = createEventModule(
  publicOnEnterpriseItemCreated
);
/**
 * Triggered when an item's category links change.
 */
export const onEnterpriseItemItemCategoriesChanged: BuildEventDefinition<
  typeof publicOnEnterpriseItemItemCategoriesChanged
> &
  typeof publicOnEnterpriseItemItemCategoriesChanged = createEventModule(
  publicOnEnterpriseItemItemCategoriesChanged
);
/**
 * Triggered when an item's `publishStatus` changes.
 */
export const onEnterpriseItemPublishStatusChanged: BuildEventDefinition<
  typeof publicOnEnterpriseItemPublishStatusChanged
> &
  typeof publicOnEnterpriseItemPublishStatusChanged = createEventModule(
  publicOnEnterpriseItemPublishStatusChanged
);
/**
 * Triggered when an item is updated.
 */
export const onEnterpriseItemUpdated: BuildEventDefinition<
  typeof publicOnEnterpriseItemUpdated
> &
  typeof publicOnEnterpriseItemUpdated = createEventModule(
  publicOnEnterpriseItemUpdated
);

export {
  MediaType,
  PublishStatus,
  SortOrder,
  WebhookIdentityType,
} from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.universal.js';
export {
  EnterpriseMediaItem,
  ItemAssets,
  ItemAssetsAssetsOneOf,
  VideoResolution,
  Archive,
  Model3D,
  ItemCategoriesChanged,
  ItemUploadCallbackRequest,
  ItemUploadCallbackResponse,
  GenerateFileUploadUrlRequest,
  GenerateFileUploadUrlResponse,
  ImportFileRequest,
  ImportFileResponse,
  BulkImportFilesRequest,
  BulkImportFilesResponse,
  BulkImportFilesResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  SearchItemsRequest,
  Search,
  SearchPagingMethodOneOf,
  Sorting,
  SearchDetails,
  Paging,
  SearchItemsResponse,
  PagingMetadataV2,
  Cursors,
  QueryItemsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  QueryItemsResponse,
  UpdateItemRequest,
  UpdateItemResponse,
  PublishStatusChanged,
  BulkUpdateItemRequest,
  BulkUpdateItemResponse,
  BulkItemUpdateResult,
  GetItemRequest,
  GetItemResponse,
  LinkItemToCategoriesRequest,
  LinkItemToCategoriesResponse,
  UnlinkItemFromCategoriesRequest,
  UnlinkItemFromCategoriesResponse,
  OverwriteItemCategoriesRequest,
  OverwriteItemCategoriesResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  EnterpriseItemCreatedEnvelope,
  EnterpriseItemItemCategoriesChangedEnvelope,
  EnterpriseItemPublishStatusChangedEnvelope,
  EnterpriseItemUpdatedEnvelope,
  ItemUploadCallbackOptions,
  GenerateFileUploadUrlOptions,
  ImportFileOptions,
  BulkImportFilesOptions,
  EnterpriseMediaItemSearchSpec,
  ItemsQueryResult,
  ItemsQueryBuilder,
  EnterpriseMediaItemQuerySpec,
  UpdateItem,
  BulkUpdateItemOptions,
  LinkItemToCategoriesOptions,
  UnlinkItemFromCategoriesOptions,
  OverwriteItemCategoriesOptions,
} from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.universal.js';
export { utils } from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.universal.js';
export {
  MediaTypeWithLiterals,
  PublishStatusWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonSearchWithEntityContext,
  EnterpriseMediaItemSearch,
  CommonQueryWithEntityContext,
  EnterpriseMediaItemQuery,
} from './media-enterprise-public-media-v1-enterprise-item-enterprise-media-items.universal.js';
